import "core-js/modules/es.array.is-array.js";
import { FhtLeancloudCustomMessageType } from "@/common/types";
import { FHTMessageType } from "@/models/MessageTypes";
import { assert } from "@/common/assert";
export function isMarker(m) {
  assert(m, "m falsy");
  var mm = m;
  return Boolean(mm.ts);
}

function assertIsDate(d) {
  assert(d, "d falsy");
  assert(d.getMinutes, "d is not date");
}

var marker = function marker(d) {
  assertIsDate(d);
  var m = {
    ts: d
  };
  return m;
};

export var MAX_MARKER_DELTA_SECONDS = 5 * 60;
export function deltaAbsSeconds(t1, t2) {
  assertIsDate(t1);
  assertIsDate(t2);
  return Math.abs(Math.ceil((t1.getTime() - t2.getTime()) / 1000));
}
export function padChatMessagesWithMarker(msgs) {
  assert(msgs, "msgs falsy");
  assert(Array.isArray(msgs), "msgs is not array");
  if (msgs.length === 0) return msgs;
  var res = [marker(msgs[0].timestamp)];

  for (var i = 0; i < msgs.length - 1; i++) {
    var curr = msgs[i];
    var next = msgs[i + 1];
    assert(curr, "curr falsy");
    assert(next, "next falsy");
    res.push(curr);

    if (deltaAbsSeconds(curr.timestamp, next.timestamp) > MAX_MARKER_DELTA_SECONDS) {
      res.push(marker(next.timestamp));
    }
  }

  res.push(msgs[msgs.length - 1]);
  return res;
}
export function isMessagePaddedWithMarker(m) {
  var cm = m;

  if (cm.messageType === FHTMessageType.RichCustomMessage && cm.customType === FhtLeancloudCustomMessageType.DataSync) {
    return false;
  } else {
    return true;
  }
}